module.exports = __webpack_public_path__ + "media/images/icons/illustration/phone-31dc3b4e1dc5eb73a538e4b3924581c0.svg";